import { Footer } from "layout/components/footer/footer"
import { Contact } from "pages/home/containers/contact/contact"
import { HARDCODED_RATING, HARDCODED_RATINGS_TOTAL } from "pages/home/home"
import { useEffect } from "react"
import { TravauxMain } from "./containers/main"
import { TravauxTypes } from "./containers/types"

export const Travaux = () => {

    useEffect(() => {
        document.title = "Rénovation d'intérieur"
    }, [])

    return (
        <>
            <TravauxMain />
            <TravauxTypes />
            <Contact gray />
            <Footer rating={HARDCODED_RATING} user_ratings_total={HARDCODED_RATINGS_TOTAL} />
        </>
    )
}